import api from './api'
import CallHelper from '@/helpers/call.helper'

class PropertyService {
    async get(params = {}) {
        return CallHelper.getDataRecursive('/property', params, (data, response) => {
            if(data.length) {
                data = [...data, ...response.data.properties]
            } else {
                data = response.data.properties
            }

            return data
        },)
    }

    async getInstance(uuid) {
        return api.get('/property/' + uuid)
    }

    async getByOwner(params = {}) {
        return api.get('/property/owner', params)
    }

    async create(property) {
        return api.post('/property', {
                account_uuid: property.account_uuid,
                name: property.name,
                type: property.type,
                usage: property.usage,
                estimate: property.estimate,
            })
            .then(response => response.data);
    }

    async modify(property) {
        return api.patch('/property/' + property.uuid, {
                name: property.name,
                type: property.type,
                usage: property.type,
                estimate: property.estimate,
            })
            .then(response => response.data)
    }

    async delete(property) {
        return api.delete('/property/' + property.uuid)
            .then(response => response.data);
    }

    async addOwners(property, params) {
        return api.post('/property/' + property.uuid + '/owner', params)
        .then(response => response.data);
    }

    async addPersons(property, params) {
        let returns = []

        params.persons.forEach((item) => {
            returns.push(api.post('/person/property', {
                    property_uuid: property.uuid,
                    person_uuid: item.person,
                    legal_structure_uuid: item.legal_structure,
                    type: item.type,
                    part: item.part,
                })
                .then((response) => response.data)
            )
        })

        return returns
    }
}

export default new PropertyService();
